import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Header from "../header";
import "./invite.css";

export default class Invite extends Component {
  render() {
      const invitee = this.props.league === "BSL" ? "Jaime" : "Paul";
      const league = this.props.league === "BSL" ? "Barnet Sunday League" : "London Unity League";
      const name = this.props.name;

    return (
      <Grid fluid>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <Header subtitle="18/19 CHANGES" />
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="intro">
              <span>
                {name && (<span>{name} - </span>)}We’re making some changes to the club and want you to get
                involved!
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">In short</p>
              <ul>
                <li>We’re going to field a team in the London Unity League</li>
                <li>
                  We’re going to field a separate team in the Barnet Sunday
                  League
                </li>
                <li>We’re moving to a much nicer home pitch</li>
                <li>
                  We’re affiliating to a County FA – The Amateur Football
                  Alliance (AFA)
                </li>
                <li>We’re getting new equipment for training and match days</li>
                <li>We’re getting new kits</li>
                <li>We’re generally trying to do everything a bit better</li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">Why?</p>
              <p>
                To make sure we have more football and more fun. Fielding two
                sides means 36 games of football in the next season, 18 of which
                we look forward to playing on our nice new pitch instead of the
                lumpy, bog at New River.
              </p>
              <p>
                Having two teams means each team will be made of the same
                familiar faces with room to grow for new members - one of the
                things that made a real difference to our performance last year
                was team consistency.
              </p>
              <p>
                Having two teams also means more people for training, so we can
                train more regularly, with better equipment, play better
                football, and enjoy it even more.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">How?</p>
              <ul>
                <li>
                  We’re introducing an annual membership fee of £20 – this
                  covers things like league subscriptions, player registration
                  fees, affiliation fees, public liability insurance, personal
                  injury insurance etc
                </li>
                <li>
                  We’re changing the match day subs to £10, home & away, card
                  only – this makes things much simpler and covers the cost of
                  the (new and improved) pitch and the ref
                </li>
                <li>
                  Anything left over from the above goes back in to the club as
                  always to pay for match balls, training equipment, trophies
                  etc
                </li>
                <li>
                  As part of the FA affiliation, and so we can get stuff done,
                  we’ve formalised the board with a club constitution, player
                  code of conduct, minutes, budget etc – all part of taking the
                  next step and a good opportunity to make sure everybody gets a
                  say
                </li>
                <li>
                  We’ve got further sponsorship to fund purchasing the new kit
                  and some of the new equipment and are looking for more
                </li>
                <li>
                  We’ll be running more regular training with better equipment
                  and more focus from Keith to keep us on our toes and out of
                  breath
                </li>
                <li>
                  Paul Francis has agreed to take on managing the LUL team and
                  Jaime Randall the BSL team
                </li>
                <li>
                  We’re moving to a new, smaller, members only facebook group to
                  make all of this easier
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        {!!this.props.league && (<Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">What's Next?</p>
              <p>
              Jaime and Paul have fought it out over players for the two new teams and <strong>{invitee} would like you to play with them in the {league} team</strong>. 
              </p>
              <p>
              If nothing I’ve said has put you off then let me know and accept the invite to the new facebook group and we’ll take things from there. If you’ve got any questions, reply back to this I’ll do my best to get them answered.
              </p>
              <p>
              If for any reason you don’t like the sound of that please drop me a message and let me know – we’ve sounded this out with a number of you already but it’s harder than it looks trying to organise this much change, it’s all been done to make the club more fun for everyone, but we really don’t want to lose anyone in the process.
              </p>
            </div>
          </Col>
        </Row>)}        
        {!this.props.league && (<Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">Want to get involved?</p>
              <p>
              We’re looking at putting on a number of summer training and trial sessions over the next few months. Let me know if you want to come down and I’ll send you the details.
              </p>
              <p>
              We’ll be closing this facebook group off and starting a new soon so if we don’t hear from you but you want to stay in touch join the public group here <a href="https://www.facebook.com/groups/afcmuswellhill/">https://www.facebook.com/groups/afcmuswellhill/</a>
              </p>
            </div>
          </Col>
        </Row>)}
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/invite/index.js